export type RefundStatus = 'PENDING' | 'SUCCESS' | 'REJECTED';

export interface Refund {
  name: string;
  status: RefundStatus;
}

export const refundFromResponse = (responseData: any): Refund => ({
  name: responseData.product.name,
  status: responseData.status,
});
